import React, { useState, useCallback } from 'react';

import {
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton as MuiIconButton,
  styled,
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Logout from '@mui/icons-material/Logout';
import SecurityIcon from '@mui/icons-material/Security';

import { useLogout, useRedirect } from 'react-admin';

const IconButton = styled(MuiIconButton)({
  width: 36,
  height: 36,
  '& svg': {
    width: 33,
    height: 33,
  },
});

const NavbarUserDropdown = () => {
  const [anchorMenu, setAnchorMenu] = useState<(EventTarget & HTMLButtonElement) | null>(null);
  const logout = useLogout();
  const redirect = useRedirect();

  const toggleMenu: React.MouseEventHandler<HTMLButtonElement> = useCallback((event) => {
    setAnchorMenu(event.currentTarget);
  }, [setAnchorMenu]);

  const closeMenu = useCallback(() => {
    setAnchorMenu(null);
  }, [setAnchorMenu]);

  const handleSignOut = useCallback(() => {
    logout();
  }, [logout]);

  const handleSecurity = useCallback(() => {
    setAnchorMenu(null);
    redirect('/security');
  }, [setAnchorMenu, redirect]);

  return (
    <>
      <Tooltip title="Account">
        <IconButton
          aria-owns={anchorMenu ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="medium"
        >
          <AccountCircle />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={!!anchorMenu}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleSecurity}>
          <ListItemIcon>
            <SecurityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Security</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleSignOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          <ListItemText>Sign out</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default NavbarUserDropdown;
